export default __webpack_public_path__ + "static/media/15-terminal.517ece03.jpg";